import { z } from "zod";

export const questionnaireSchema = z.object({
  id: z.string({ coerce: true }),
  name: z.string(),
  color: z.string()
});

export type Questionnaire = z.infer<typeof questionnaireSchema>;
